import { Colors } from 'src/components/theme'

type Props = {
  color?: string
}
export const Solid = (props: Props) => {
  const { color } = props

  return (
    <svg width="40" height="10" viewBox="0 0 40 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect y="3" width="40" height="4" fill={color || Colors.blueDark} />
      <circle cx="20" cy="5" r="4.5" fill={color || Colors.blueDark} stroke="transparent" />
    </svg>
  )
}
